import { Fetch } from './shared/general';

//#region ======== ACTIONS ========
const actions = {
    //File Management
    //=========== LISTS ===========
    userVerifyold: "user_user_verify",
    userVerify: "verify_user",
    userVerifyDtk: "verify_user_dtk",
    userProfile: "user_user_profile",
    userLists: "user_user_list",
    userAllLists: "user_allUsers_list",
    userUpdate: "user_user_update",
    userUpdatePassword: "user_user_updatePassword",
    userCreate: "user_user_create",
    allUserLists: "list_all_user",

};
//#endregion


//#region ========== API FUNCTIONS ===========
export async function user_user_verify(data) {
    
    return Fetch({ action: actions.userVerify, data: data });
}

export async function user_user_verify_dtk(data) {
    
    return Fetch({ action: actions.userVerifyDtk, data: data });
}

export async function user_user_list(data) {
    return Fetch({ action: actions.userLists, data: data });
}

export async function user_allUsers_list(data) {
    return Fetch({ action: actions.userAllLists, data: data });
}

export async function user_user_profile(data) {
    return Fetch({ action: actions.userProfile, data: data });
}

export async function user_user_rename(data) {
    return Fetch({ action: actions.userUpdate, data: data });
}

export async function user_user_createUser(data) {
    return Fetch({ action: actions.userCreate, data: data });
}

export async function user_user_updateUser(data) {
    return Fetch({ action: actions.userUpdate, data: data });
}

export async function user_user_updatePassword(data) {
    return Fetch({ action: actions.userUpdatePassword, data: data });
}

export async function list_all_user(data) {
    return Fetch({ action: actions.allUserLists, data: data })
}
//#endregion